import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Button } from '@vk-hr-tek/ui/Button';
import { Icon } from '@vk-hr-tek/ui/Icon';
import { Tooltip } from '@vk-hr-tek/ui/Tooltip';
import {
  ContentSurveysOpenAccess,
  ContentSurveysCloseAccess,
} from '@vk-hr-tek/ui/graphics';

import { ProcessedSurveyPassingItem } from '../../../mappers';

interface ContentSurveysItemCompletedProps {
  survey: ProcessedSurveyPassingItem;
  openSurveyAnalytics: () => void;
  onDownloadReport: () => void;
}

export const ContentSurveysItemCompleted = ({
  survey,
  openSurveyAnalytics,
  onDownloadReport,
}: ContentSurveysItemCompletedProps) => {
  return (
    <Box display="flex" gap="8" pl="24" pr="144" py="16" position="relative">
      <Box display="flex" flexDirection="column" gap="16">
        <Typography variant="body2">
          {survey.isPassing && !survey.isCompleted && (
            <>Благодарим за прохождение опроса! Ваши ответы записаны</>
          )}
          {survey.isPassing && survey.isCompleted && (
            <>
              Благодарим за прохождение опроса! Ваши ответы записаны.
              <br />
              Опрос закрыт, ответы больше не принимаются
            </>
          )}
          {!survey.isPassing && survey.isCompleted && (
            <>
              Опрос закрыт, ответы больше не принимаются.
              <br />
              Будем рады вашему участию в следующих опросах
            </>
          )}
        </Typography>

        <Box display="flex" gap="16" height="32px">
          {survey.actions?.results && (
            <Button
              size="small"
              variant="quaternary"
              onClick={openSurveyAnalytics}
              startIcon={
                <Icon name="poll" size="16" color="text.light.primary" />
              }
            >
              Результаты
            </Button>
          )}

          {survey.actions?.report && (
            <Tooltip placement="top" title="Скачать отчет (.xlsx)">
              <Button
                size="small"
                onClick={onDownloadReport}
                variant="tertiaryLight"
                startIcon={
                  <Icon
                    name="download_outline"
                    size="16"
                    color="text.light.primary"
                  />
                }
              >
                Отчет
              </Button>
            </Tooltip>
          )}
        </Box>
      </Box>

      <Box
        position="absolute"
        right="16px"
        top="0px"
        bottom="0px"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {survey.isCompleted ? (
          <ContentSurveysCloseAccess />
        ) : (
          <ContentSurveysOpenAccess />
        )}
      </Box>
    </Box>
  );
};
